import { SvgIconComponent } from "@mui/icons-material";
import { ADMIN_TYPE, FORM_TYPE, ROUTES } from "../constant";

const sideBar: {formSideBar: { title: string, route: string, icon: SvgIconComponent, permission: string }[], adminSideBar: { title: string, route: string, icon: SvgIconComponent, permission: string }[]} = {
    formSideBar: [
        
        {
            "title": FORM_TYPE.ONBOARD_EMPLOYEE.TITLE,
            "route": ROUTES.FORMS + "?type=" + FORM_TYPE.ONBOARD_EMPLOYEE.TYPE,
            "icon": FORM_TYPE.ONBOARD_EMPLOYEE.ICON,
            "permission": FORM_TYPE.ONBOARD_EMPLOYEE.PERMISSION
        },
        {
            "title": FORM_TYPE.OFFBOARD_EMPLOYEE.TITLE,
            "route": ROUTES.FORMS + "?type=" + FORM_TYPE.OFFBOARD_EMPLOYEE.TYPE,
            "icon": FORM_TYPE.OFFBOARD_EMPLOYEE.ICON,
            "permission": FORM_TYPE.OFFBOARD_EMPLOYEE.PERMISSION
        },
        {
            "title": FORM_TYPE.MANAGE_SITE_USERS.TITLE,
            "route": ROUTES.FORMS + "?type=" + FORM_TYPE.MANAGE_SITE_USERS.TYPE,
            "icon": FORM_TYPE.MANAGE_SITE_USERS.ICON,
            "permission": FORM_TYPE.MANAGE_SITE_USERS.PERMISSION
        },
        {
            "title": FORM_TYPE.MANAGE_SHARED_MAILBOXES.TITLE,
            "route": ROUTES.FORMS + "?type=" + FORM_TYPE.MANAGE_SHARED_MAILBOXES.TYPE,
            "icon": FORM_TYPE.MANAGE_SHARED_MAILBOXES.ICON,
            "permission": FORM_TYPE.MANAGE_SHARED_MAILBOXES.PERMISSION
        },
        {
            "title": FORM_TYPE.NEW_SITE_TEAM.TITLE,
            "route": ROUTES.FORMS + "?type=" + FORM_TYPE.NEW_SITE_TEAM.TYPE,
            "icon": FORM_TYPE.NEW_SITE_TEAM.ICON,
            "permission": FORM_TYPE.NEW_SITE_TEAM.PERMISSION
        },
        {
            "title": FORM_TYPE.OTHER_REQUEST.TITLE,
            "route": ROUTES.FORMS + "?type=" + FORM_TYPE.OTHER_REQUEST.TYPE,
            "icon": FORM_TYPE.OTHER_REQUEST.ICON,
            "permission": FORM_TYPE.OTHER_REQUEST.PERMISSION
        }
    
    ],
    adminSideBar: [
        {
          title: ADMIN_TYPE.ADMIN_USER_PERMISSION.TITLE,
          icon:  ADMIN_TYPE.ADMIN_USER_PERMISSION.ICON,
          route: ROUTES.ADMIN.USER_PERMISSIONS,
          permission:  ADMIN_TYPE.ADMIN_USER_PERMISSION.PERMISSION
        },
        {
          title: ADMIN_TYPE.ADMIN_SYSTEM_CREDENTIAL.TITLE,
          icon: ADMIN_TYPE.ADMIN_SYSTEM_CREDENTIAL.ICON,
          route: ROUTES.ADMIN.SYSTEM_CREDENTIALS,
          permission:  ADMIN_TYPE.ADMIN_SYSTEM_CREDENTIAL.PERMISSION
        },
        {
          title: ADMIN_TYPE.ADMIN_COLLECTOR.TITLE,
          icon: ADMIN_TYPE.ADMIN_COLLECTOR.ICON,
          route: ROUTES.ADMIN.COLLECTORS,
          permission:  ADMIN_TYPE.ADMIN_COLLECTOR.PERMISSION
        },
    ]
}

export default sideBar;
